import { API } from './apiClient';

const API_NAME = 'useradminapi';

export async function listUsers(paginationToken = null, limit = 50) {
  const queryParams = new URLSearchParams();
  if (limit) queryParams.append('limit', limit);
  if (paginationToken) queryParams.append('paginationToken', paginationToken);

  const path = queryParams.toString() ? `/users?${queryParams.toString()}` : '/users';
  const response = await API.get(API_NAME, path);
  return {
    users: response.users,
    paginationToken: response.paginationToken
  };
}

export async function listGroups() {
  const response = await API.get(API_NAME, '/groups');
  return response.groups;
}

export async function addUserToGroup(username, groupName) {
  return API.post(API_NAME, `/users/${encodeURIComponent(username)}/groups`, {
    body: { groupName }
  });
}

export async function removeUserFromGroup(username, groupName) {
  return API.del(API_NAME, `/users/${encodeURIComponent(username)}/groups/${encodeURIComponent(groupName)}`);
}

export async function updateUserAttributes(username, attributes) {
  return API.put(API_NAME, `/users/${encodeURIComponent(username)}/attributes`, {
    body: { attributes }
  });
}

export async function setUserEnabled(username, enabled) {
  return API.put(API_NAME, `/users/${encodeURIComponent(username)}/enabled`, {
    body: { enabled }
  });
}

export async function addUserToTenant(email) {
  return API.post(API_NAME, '/tenant/users', {
    body: { email }
  });
}

export async function createUser(email, temporaryPassword, groupName, handle) {
  return API.post(API_NAME, '/users', {
    body: { email, temporaryPassword, groupName, handle }
  });
}

export async function forceLogout(accountId) {
  return API.post('auth', '/auth/admin/force-logout', {
    body: { accountId }
  });
}

export async function resendAccountId(username) {
  return API.post(API_NAME, `/users/${encodeURIComponent(username)}/resend-account-id`);
}
